/** Operator log entry — the single history that answers the question
 *  "was it a technical fault or the graphics operator's mistake".
 *
 *  - command  — a command the operator sent and the server result (ok / error code)
 *  - graphics — the on-air state actually changed (from the replicant diff)
 *  - error    — server/browser errors (PFL/dostats, JS exception, DB)
 *  - system   — the graphics page connected/disconnected, the server restarted */
export type OpLogKind = "command" | "graphics" | "error" | "system";
export type OpLogLevel = "info" | "warn" | "error";

export type OpLogEntry = {
  id: number;
  /** Unix ms. */
  ts: number;
  kind: OpLogKind;
  level: OpLogLevel;
  userId: string | null;
  username: string | null;
  slug: string | null;
  action: string;
  detail: string | null;
  /** Error code (the `error` from the ack, `no_ack`, the exception name). */
  code: string | null;
  durationMs: number | null;
};

export const OPLOG_MESSAGE = "oplog.entry";
